import { useState } from "react";
import { Link } from "react-router-dom";
import { Leaf, Menu, X } from "lucide-react";

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-center items-center py-4 relative">
          {/* Logo (Left) */}
          <Link to="/" className="absolute left-4 flex items-center space-x-2">
            <Leaf className="h-8 w-8 text-primary" />
            <span className="text-xl font-bold text-primary">
              Wholefoods.ai
            </span>
          </Link>

          {/* Desktop Menu (Centered) */}
          <nav className="hidden md:flex justify-center">
            <ul className="flex space-x-8">
              <li>
                <Link
                  to="/"
                  className="font-medium text-gray-700 hover:text-primary-600 transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="font-medium text-gray-700 hover:text-primary-600 transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="https://learning.wholefoods.ai/"
                  className="font-medium text-gray-700 hover:text-primary-600 transition-colors"
                >
                  Learning
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="font-medium text-gray-700 hover:text-primary-600 transition-colors"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="https://directory.wholefoods.ai/"
                  className="font-medium text-gray-700 hover:text-primary-600 transition-colors"
                >
                  Directory
                </Link>
              </li>
              <li>
                <Link
                  to="https://recipes.wholefoods.ai/"
                  className="font-medium text-gray-700 hover:text-primary-600 transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Recipes
                </Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Menu Button (Right) */}
          <button
            className="absolute right-4 md:hidden flex items-center text-gray-700 hover:text-primary-600"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="h-8 w-8" /> : <Menu className="h-8 w-8" />}
          </button>
        </div>

        {/* Mobile Menu Dropdown */}
        {isOpen && (
          <div className="md:hidden bg-white shadow-lg absolute top-8 left-0 right-0 z-50 text-center">
            <ul className="flex flex-col items-center space-y-6 py-6">
              <li>
                <Link
                  to="/"
                  className="font-medium text-gray-700 hover:text-primary-600 transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="font-medium text-gray-700 hover:text-primary-600 transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="font-medium text-gray-700 hover:text-primary-600 transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="https://learning.wholefoods.ai/"
                  className="font-medium text-gray-700 hover:text-primary-600 transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Learning
                </Link>
              </li>
              <li>   <Link
                  to="https://directory.wholefoods.ai/"
                  className="font-medium text-gray-700 hover:text-primary-600 transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Directory
                </Link></li>


              <li>
                <Link
                  to="https://recipes.wholefoods.ai/"
                  className="font-medium text-gray-700 hover:text-primary-600 transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Recipes
                </Link>
              </li>
            </ul>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
